/* eslint-disable no-bitwise */
export const TOTP_STEP_SECONDS = 30;

function int64BigEndian(counter) {
  const buffer = new ArrayBuffer(8);
  const view = new DataView(buffer);
  const high = Math.floor(counter / 0x100000000);
  const low = counter >>> 0;
  view.setUint32(0, high, false);
  view.setUint32(4, low, false);
  return buffer;
}

async function hmacSha1(keyBytes, dataBuffer) {
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'HMAC', hash: 'SHA-1' },
    false,
    ['sign']
  );
  const signature = await crypto.subtle.sign('HMAC', cryptoKey, dataBuffer);
  return new Uint8Array(signature);
}

export async function generateTotp(secretKey, digits = 6) {
  const epochSeconds = Math.floor(Date.now() / 1000);
  const counter = Math.floor(epochSeconds / TOTP_STEP_SECONDS);
  const key = new TextEncoder().encode(String(secretKey || ''));
  const hash = await hmacSha1(key, int64BigEndian(counter));
  const offset = hash[19] & 0x0f;
  const bin = (
    ((hash[offset] & 0x7f) << 24)
    | ((hash[offset + 1] & 0xff) << 16)
    | ((hash[offset + 2] & 0xff) << 8)
    | (hash[offset + 3] & 0xff)
  ) >>> 0;
  const otp = bin % (10 ** digits);
  return String(otp).padStart(digits, '0');
}
